import { reactive } from "@vue/composition-api";
import { apiEndpoint } from "@/configs/api/api-configs";

export function uploadPointModel(){
  const getCampaignListModel = reactive({
    api: `${apiEndpoint.bcrm_platform}/ExchangePointUpload/Campaign_List`,
    method: "POST",
    xRequest: "",
    payload: {
      Page: 1,
      Limit: 10,
      Filters: [{ Seq: 1, Key: "query", Value: "" }],
      Ordering: [{ Seq: 1, Key: "seq", Direction: "asc" }],
    },
  });

  const createCampaignModel = reactive({
    api: `${apiEndpoint.bcrm_platform}/ExchangePointUpload/Create`,
    method: "POST",
    xRequest: "",
    payload: {
      EXC_AssetId : 0,
      Campaign_Name : null,
      Detail : null
    },
  });

  const editCampaignModel = reactive({
    api: `${apiEndpoint.bcrm_platform}/ExchangePointUpload/Edit`,
    method: "POST",
    xRequest: "",
    payload: {
      Campaign_Id : 1,
      Import_File : null,
      EXC_AssetId : 1,
      Campaign_Name : null,
      Detail : null
    },
  });

  const deleteCampaignModel = reactive({
    api: `${apiEndpoint.bcrm_platform}/ExchangePointUpload/Delete`,
    method: "POST",
    xRequest: "",
    payload: {
      Campaign_Id : 1
    },
  });

  const getCampaignDetailModel = reactive({
    api: `${apiEndpoint.bcrm_platform}/ExchangePointUpload/Detail`,
    method: "POST",
    xRequest: "",
    payload: {
      Campaign_Id : 1,
      Page: 1,
      Limit: 10,
      Filters: [{ Seq: 1, Key: "query", Value: "" }],
      Ordering: [{ Seq: 1, Key: "seq", Direction: "asc" }],
    },
  });

  const actionCampaignModel = reactive({
    api: `${apiEndpoint.bcrm_platform}/ExchangePointUpload/Action`,
    method: "POST",
    xRequest: "",
    payload: {
      Campaign_Id : 1,
      Action_Id : 1
    },
  });

  const ExportCampaignModel = reactive({
    api: `${apiEndpoint.bcrm_platform}/ExchangePointUpload/Export`,
    method: "POST",
    xRequest: "",
    payload: {
      Campaign_Id : 1,
    },
  });

  const RefCodeModel = reactive({
    api: `${apiEndpoint.bcrm_platform}/ExchangePointUpload/RefCode`,
    method: "POST",
    xRequest: "",
    payload: {
    },
  });


  return{
    getCampaignListModel,
    createCampaignModel,
    editCampaignModel,
    deleteCampaignModel,
    getCampaignDetailModel,
    actionCampaignModel,
    ExportCampaignModel,
    RefCodeModel
  };
}